import { useQuery } from '@tanstack/react-query';
import type { EnrichedSearchSubscriptionResponse } from '@//app/api/protected/subscriptions/search/enriched';
import { useAuth } from '@//providers/AuthProvider';
import { useApiBaseUrl } from '@//providers/MarketSettingsProvider';
import { httpClientGetAuthorizedJson } from '../../httpClient';

export const SEARCH_SUBSCRIPTIONS_ENRICHED_CACHE_KEY =
  'api/protected/subscriptions/search/enriched';

const useEnrichedSearchSubscriptions = () => {
  const { initialized, decodedToken } = useAuth();
  const apiBaseUrl = useApiBaseUrl();
  const query = useQuery<EnrichedSearchSubscriptionResponse>({
    queryKey: [SEARCH_SUBSCRIPTIONS_ENRICHED_CACHE_KEY, decodedToken?.sub],
    queryFn: async () => {
      const url = `${apiBaseUrl}/api/protected/subscriptions/search/enriched`;
      return await httpClientGetAuthorizedJson<EnrichedSearchSubscriptionResponse>(url);
    },
    enabled: initialized,
  });

  return query;
};

export default useEnrichedSearchSubscriptions;
